import layout from 'ant-design-vue/lib/layout';
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

let routes = [
	{
		// will match everything
		path: '*',
		component: () => import('../views/404.vue'),
	},

	{
		path: '/scan',
		name: 'Scan-In',
		layout:"scan",
		component: () => import('../views/Scan-In.vue'),
	},


	{
		path: '/',
		name: '客戶清單',
		layout: "custom",
		component: () => import('../views/admin/Member/List.vue'),
	},
	{
		path: '/member',
		name: '客戶清單',
		layout: "custom",
		component: () => import('../views/admin/Member/List.vue'),
	},
	{
		path: '/member/add',
		name: '客戶導入',
		layout: "custom",
		component: () => import('../views/admin/Member/AddOrEdit.vue'),
	},
	{
		path: '/order',
		name: '訂單清單',
		layout: "custom",
		component: () => import('../views/admin/Order/List.vue'),
	},
	{
		path: '/order/add',
		name: '訂單導入',
		layout: "custom",
		component: () => import('../views/admin/Order/AddOrEdit.vue'),
	},
	{
		path: '/product',
		name: '產品清單',
		layout: "custom",
		component: () => import('../views/admin/Product/List.vue'),
	},
	{
		path: '/product/add',
		name: '產品導入',
		layout: "custom",
		component: () => import('../views/admin/Product/AddOrEdit.vue'),
	},

	{
		path: '/receipt',
		name: '生產記錄',
		layout: "custom",
		component: () => import('../views/admin/Receipt/List.vue'),
	},
	{
		path: '/receipt/add',
		name: '生產記錄Store',
		layout: "custom",
		component: () => import('../views/admin/Receipt/ScanAdd.vue'),
	},
	{
		path: '/receipt/edit/:id',
		name: '生產記錄Store',
		layout: "custom",
		component: () => import('../views/admin/Receipt/Edit.vue'),
	},

	{
		path: '/administrators',
		name: '管理員清單',
		layout: "custom",
		// component: () => import('../views/admin/Administrators/List.vue'),
		component: () => import('../views/admin/Administrators/List.vue'),
	},
	{
		path: '/administrators/add',
		name: '新建管理員',
		layout: "custom",
		component: () => import('../views/admin/Administrators/AddOrEdit.vue'),
	},
	{
		path: '/administrators/edit/:id',
		name: '更新管理員',
		layout: "custom",
		component: () => import('../views/admin/Administrators/AddOrEdit.vue'),
	},

	//
	{
		path: '/sign-in',
		name: 'Sign-In',
		component: () => import('../views/Sign-In.vue'),
	},


]

// Adding layout property from each route to the meta
// object so it can be accessed later.
function addLayoutToRoute(route, parentLayout = "default") {
	route.meta = route.meta || {};
	route.meta.layout = route.layout || parentLayout;

	if (route.children) {
		route.children = route.children.map((childRoute) => addLayoutToRoute(childRoute, route.meta.layout));
	}
	return route;
}

routes = routes.map((route) => addLayoutToRoute(route));

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
	scrollBehavior(to, from, savedPosition) {
		if (to.hash) {
			return {
				selector: to.hash,
				behavior: 'smooth',
			}
		}
		return {
			x: 0,
			y: 0,
			behavior: 'smooth',
		}
	}
})

// 在 router/index.js 或相關路由設定檔中
router.beforeEach((to, from, next) => {
	document.title = 'oimo'
	next()
})

export default router
